export default __webpack_public_path__ + "static/media/activity-parking.a36c2361.svg";